<template>
  <div class="flight-pad-bags">
    <div class="flight-pad-bags__flex">
      <div
        class="flight-pad-bags__bag-container"
        v-b-popover.hover.top="'Numero di bagagli personali inclusi per ogni passeggero adulto'"
      >
        <span v-html="svg_backpack(bags_quantity_color(hand_bags), 17)"></span>
        <span
          class="flight-pad-bags__quantity semibold"
          :style="{
            color: bags_quantity_color(hand_bags),
          }"
        >
          {{ hand_bags }}
        </span>
      </div>
      <div
        class="flight-pad-bags__bag-container"
        v-b-popover.hover.top="'Numero di bagagli in stiva incluso per ogni passeggero adulto'"
      >
        <span v-html="svg_luggage(bags_quantity_color(luggage_bags), 21, 31)"></span>
        <span
          class="flight-pad-bags__quantity semibold"
          :style="{
            color: bags_quantity_color(luggage_bags),
          }"
        >
          {{ luggage_bags }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { backpack, luggage } from '@/components/svg/bags';
import { bags_quantity_color, hand_bags_per_adult, luggage_bags_per_adult } from './utilities';

export default {
  name: 'flight-pad-bags',
  props: {
    flight_offer: Object,
    itinerary_index: Number,
  },
  methods: {
    svg_backpack: backpack,
    svg_luggage: luggage,
    bags_quantity_color,
  },
  computed: {
    hand_bags() {
      return hand_bags_per_adult(this.flight_offer);
    },
    luggage_bags() {
      return luggage_bags_per_adult(this.flight_offer, this.itinerary_index);
    },
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-bags {
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;

  &__quantity {
    line-height: 1;
  }

  &__bag-container {
    display: flex;
    gap: 2.5px;

    &:first-child {
      margin-right: 5px;
    }

    &:last-child {
      margin-left: 5px;
    }
  }
}
</style>
